export default __webpack_public_path__ + "static/media/autoBtn@2x.073fefe9.png";